import { statusColor } from "../tokens";

interface Props {
  status: string;
  pulse?: boolean;
  size?: number;
}

export function StatusDot({ status, pulse = false, size = 8 }: Props) {
  const color = statusColor(status);
  return (
    <span
      style={{ position: "relative", display: "inline-flex", width: size, height: size }}
    >
      {pulse && (
        <span
          style={{
            position: "absolute", inset: 0,
            background: color,
            borderRadius: "50%",
            opacity: 0.4,
            animation: "cm-halo-pulse 1.8s ease-in-out infinite",
          }}
        />
      )}
      <span
        style={{
          position: "relative",
          width: size,
          height: size,
          borderRadius: "50%",
          background: color,
          boxShadow: `0 0 ${size}px ${color}`,
        }}
      />
    </span>
  );
}
